import React, { useState } from "react";

import { ROUTES } from "./Route";
import Login from "../Account/Login";
import TrainingsManagementScreen from "./TrainingManagement";

export default function TrainingManagement() {
  const [page, setPage] = useState(ROUTES.TRANING_MANAGEMENT);

  switch (page) {
    case ROUTES.TRANING_MANAGEMENT:
      return <TrainingsManagementScreen setPage={setPage} />;
    default:
      return <Login />;
  }
}
